import { Formatter } from './Formatter';
import { Parser } from './Parser';
import { switchRegex } from './switchRegex';

export class MetroParser extends Parser {
  private isCollectingMetroError = false;
  private metroError: string[] = [];

  constructor(public formatter: Formatter) {
    super(formatter);
  }

  parse(text: string): void | string {
    const results = this.checkMetroError(text);
    if (results) {
      return results;
    }
    return super.parse(text);
  }

  // Error for the build script wrapper in expo-updates that catches metro bundler errors.
  // This can be repro'd by importing a file that doesn't exist, then building.
  // Metro will fail to generate the JS bundle, and throw an error that should be caught here.
  checkMetroError(text: string) {
    // In expo-updates, we wrap the bundler script and add regex around the error message so we can present it nicely to the user.
    return switchRegex(text, [
      [
        /@build-script-error-begin/m,
        () => {
          this.isCollectingMetroError = true;
        },
      ],
      [
        /@build-script-error-end/m,
        () => {
          const results = this.metroError.join('\n');
          // Reset the metro collection error array (should never need this).
          this.isCollectingMetroError = false;
          this.metroError = [];
          if ('formatMetroAssetCollectionError' in this.formatter) {
            return (this.formatter as any).formatMetroAssetCollectionError(results);
          }
          throw new Error('Current `@expo/xcpretty` formatter cannot handle Metro errors');
        },
      ],
      [
        null,
        () => {
          // Collect all the lines in the metro build error
          if (this.isCollectingMetroError) {
            let results = text;
            if (!this.metroError.length) {
              const match = text.match(
                /Error loading assets JSON from Metro.*steps correctly.((.|\n)*)/m
              );
              if (match && match[1]) {
                results = match[1].trim();
              }
            }
            this.metroError.push(results);
          }
        },
      ],
    ]);
  }
}
